export const CLEAR_IGNORED_CONTACT_LIST = 'CLEAR_IGNORED_CONTACT_LIST' as const

export const clearIgnoredContactListAction = () => ({
  type: CLEAR_IGNORED_CONTACT_LIST,
})

export type ClearIgnoredContactListAction = ReturnType<
  typeof clearIgnoredContactListAction
>
